export default "__VITE_ASSET__DUZHAxxz__"